export default __webpack_public_path__ + "static/media/account.18449749.svg";